import { useState, useEffect } from "react";
import { useCRMFunction } from "../../../customwidgets/sales-manager/hooks/useCRMFunction";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";

export const useManageSeller = ( changeLoader: ChangeLoaderCallbackType, changeAlert: ChangeAlertCallbackType, open: boolean ) => {
    const { onGetAgentByUuid, onHandleAgentList } = useCRMFunction(changeAlert);
    
    const [zPos, setZPos] = useState(45)
    const [form, setForm] = useState(null);
    const [error, setError] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const [agentList, setAgentList] = useState([]);

    // REQ ------------------------------------------------
    const onHandleSave = (resp) => {
        setForm(JSON.parse(JSON.stringify(resp)));
    };

    const getAgentList = async () => {
        changeLoader(true);
        setZPos(-1);

        let resp = await onHandleAgentList();
        if(resp){
            setAgentList(JSON.parse(JSON.stringify(resp)));
        }
        setZPos(45);
        changeLoader(false);
    };

    const onHandleFindAgent = async (e) => {
        changeLoader(true);
        setZPos(-1);

        let resp = await onGetAgentByUuid(e.target.value);
        if(resp){
            let f = form;
            f["uuid"] = resp["uuid"]
            f["general"] = {
                gname: resp["gname"],
                fname: resp["fname"],
                sfname: resp["sfname"],
                email: resp["email"],
                phone: resp["phone"],
                taxid: resp["taxid"]
            }

            setForm(JSON.parse(JSON.stringify(f)));
            validateForm(f, error);
        }
        setZPos(45);
        changeLoader(false);
    };

    // FUNCT ------------------------------------------------

    const onHandleChange = (key1, key2, e) => {
        let f = form ? form : {};
        let er = error ? error : {};

        let value = e["target"] ? e["target"]["value"] : e["props"]["value"];
        
        if (key1 === "role"){
            f = {}
        }
        if (key2.includes("email")) {
            value = value.trim();
        }

        if (key2 && key1) {
            f[key1] ? f[key1][key2] = value : f[key1] = {...form[key1], [key2]: value}
        } else if(key1){
            f[key1] = value;
        }

        if (key1 === "type"){
            f[key1] = e.target.name
        }

        if (!value){
            key2 && key1 && (er[key2] = "Campo obligatorio");
        } else {
            key2 && key1 && delete er[key2];
        }
        
        setForm(JSON.parse(JSON.stringify(f)));
        setError(JSON.parse(JSON.stringify(er)));

        if (key1 === "role" && value === "agent"){
            return agentList.length === 0 && getAgentList();
        }
        validateForm(f, er);
    };

    const validateForm = (f, e) => {
        if (Object.keys(e).length === 0 && f["general"] && f["general"]["gname"] && f["general"]["fname"]  && f["general"]["email"]  && f["general"]["taxid"]  && f["general"]["phone"] && (f["role"] === "promoter" ?  f["general"]["clabe"] : true)) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    useEffect(() => {
        if (!open) {
            setForm(null);
            setError(null);
            setIsValid(true);
            setAgentList([]);
        }
    }, [open]);

    return {
        zPos,
        form,
        error,
        isValid,
        agentList,
        onHandleSave,
        onHandleChange,
        onHandleFindAgent
    };
};
